// Ported from `polished`'s `rem()` (base 16px), which is what
// `@onestore/hel/dist/utils/unit` wraps — HEL's `unit()` is a thin
// multi-value convenience over the same conversion.
function toRem(px: number): string {
  return `${px / 16}rem`
}

export function unit(value: number): string
export function unit(...values: number[]): string[]
export function unit(...values: number[]): string | string[] {
  const result = values.map(toRem)

  return result.length > 1 ? result : result[0]
}
